function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1464 0.853553L16.2929 3H2.5C1.11929 3 0 4.11929 0 5.5V8.5C0 8.77614 0.223858 9 0.5 9C0.776142 9 1 8.77614 1 8.5V5.5C1 4.67157 1.67157 4 2.5 4H16.2929L14.1464 6.14645C13.9512 6.34171 13.9512 6.65829 14.1464 6.85355C14.3417 7.04882 14.6583 7.04882 14.8536 6.85355L17.8536 3.85355C18.0488 3.65829 18.0488 3.34171 17.8536 3.14645L14.8536 0.146447C14.6583 -0.0488155 14.3417 -0.0488155 14.1464 0.146447C13.9512 0.341709 13.9512 0.658291 14.1464 0.853553ZM3.85355 16.1464L1.70711 14H15.5C16.8807 14 18 12.8807 18 11.5V8.5C18 8.22386 17.7761 8 17.5 8C17.2239 8 17 8.22386 17 8.5V11.5C17 12.3284 16.3284 13 15.5 13H1.70711L3.85355 10.8536C4.04882 10.6583 4.04882 10.3417 3.85355 10.1464C3.65829 9.95118 3.34171 9.95118 3.14645 10.1464L0.146447 13.1464C-0.0488155 13.3417 -0.0488155 13.6583 0.146447 13.8536L3.14645 16.8536C3.34171 17.0488 3.65829 17.0488 3.85355 16.8536C4.04882 16.6583 4.04882 16.3417 3.85355 16.1464Z",
  fill: "white"
});

function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.cbd909da.svg";
export { ForwardRef as ReactComponent };